import {
  OFFLINE_QUEUE_STORAGE_KEY,
  UPLOAD_STORAGE_KEY,
  activeCaseCode,
  pathWithCaseCode,
  readItemsForCase,
  readLeadDraftForCase,
} from "./case-scoped-storage";

const ResumeHubHook = {
  mounted() {
    this.syncContext();

    this.render();

    this.handleUpdate = () => this.render();
    window.addEventListener("lead-draft:updated", this.handleUpdate);
    window.addEventListener("offline-queue:updated", this.handleUpdate);
    window.addEventListener("uploads:updated", this.handleUpdate);
  },
  destroyed() {
    window.removeEventListener("lead-draft:updated", this.handleUpdate);
    window.removeEventListener("offline-queue:updated", this.handleUpdate);
    window.removeEventListener("uploads:updated", this.handleUpdate);
  },
  updated() {
    this.syncContext();
    this.render();
  },
  syncContext() {
    this.list = this.el.querySelector("[data-resume-list]");
    this.empty = this.el.querySelector("[data-resume-empty]");
    this.caseCode = activeCaseCode(this.el.dataset.caseCode);
    this.userId = this.el.dataset.userId;
  },
  render() {
    const items = [];
    // mounted() and updated() normally sync; this keeps direct render() calls current.
    this.syncContext();

    const draft = readLeadDraftForCase({
      userId: this.userId,
      caseCode: this.caseCode,
    });

    if (draft) {
      items.push({
        title: "Lead draft",
        subtitle: `Saved ${new Date(draft.savedAt).toLocaleString()}`,
        actionLabel: "Resume",
        actionHref: pathWithCaseCode("/leads/new_lead?resume_draft=1", this.caseCode),
      });
    }

    const queue = readItemsForCase(OFFLINE_QUEUE_STORAGE_KEY, this.caseCode);

    if (queue.length > 0) {
      const firstPath = queue.find((item) => item.path)?.path || window.location.pathname;

      items.push({
        title: "Queued actions",
        subtitle: `${queue.length} waiting for reconnect`,
        actionLabel: "View",
        actionHref: pathWithCaseCode(firstPath, this.caseCode),
      });
    }

    const uploads = readItemsForCase(UPLOAD_STORAGE_KEY, this.caseCode);

    if (uploads.length > 0) {
      const failed = uploads.filter((upload) => upload.status === "failed").length;
      const retrying = uploads.filter(
        (upload) => upload.status === "retrying" || upload.status === "uploading"
      ).length;
      let subtitle = `${uploads.length} file(s) pending`;
      if (failed > 0) {
        subtitle = `${failed} upload(s) need retry`;
      } else if (retrying > 0) {
        subtitle = `${retrying} upload(s) retrying`;
      }

      items.push({
        title: "Uploads in progress",
        subtitle,
        actionLabel: failed > 0 ? "Retry" : "Review",
        actionHref: pathWithCaseCode("/leads/new_lead?uploads=1", this.caseCode),
      });
    }

    if (!this.list) return;

    this.list.innerHTML = "";

    if (items.length === 0) {
      this.empty?.classList.remove("hidden");
      return;
    }

    this.empty?.classList.add("hidden");

    items.forEach((item) => {
      const wrapper = document.createElement("div");
      wrapper.className =
        "flex items-center justify-between gap-3 rounded-xl bg-isx-gray/70 px-4 py-3";
      wrapper.innerHTML = `
        <div>
          <div class="text-sm font-semibold text-isx-white">${item.title}</div>
          <div class="text-xs text-isx-ltgray">${item.subtitle}</div>
        </div>
        <a href="${item.actionHref}" class="text-xs px-3 py-1.5 rounded-lg bg-isx-babyblue-600 text-white hover:bg-isx-babyblue-500 transition-colors touch-target">${item.actionLabel}</a>
      `;
      this.list.appendChild(wrapper);
    });
  },
};

export default ResumeHubHook;
